<template>
  <div style="padding-top: 35%;">
      <div class="event_box" v-loading="loading">
        <div class="title">考勤时间修改</div>
        <div class="event_item">
          <div class="label" :style="data.Type==1?'margin-bottom:20px;':''">修正操作</div>
          <div class="content">
            <el-radio-group v-model="data.Type">
              <el-radio :label="0">取消一次</el-radio>
              <el-radio :label="1">改时一次</el-radio>
            </el-radio-group>
          </div>
          <div class="label" v-if="data.Type==1">考勤时段</div>
          <div class="content" v-if="data.Type==1">
            <el-time-picker
              is-range
              v-model="range"
              range-separator="至"
              start-placeholder="开始时间"
              format="HH:mm"
              value-format="HH:mm"
              end-placeholder="结束时间"
              style="width:100%;"
              placeholder="选择时间范围">
            </el-time-picker>
          </div>
        </div>
        <div class="event_footer">
          <el-button type="primary" @click="comfirn" style="float:right;">确 定</el-button>
          <div style="clear:both;"></div>
        </div>
      </div>
      <div v-if="failData.length" style="width: 90%;margin: 20px auto 0;">
        <div class="t_title">冲突事件及时段</div>
        <el-table :data="failData" border>
          <el-table-column prop="EventName" label="事件名称" />
          <el-table-column prop="EventName" label="事件时段">
            <template slot-scope="{ row }">
              <span>{{showTime(row.TimeBucketStart)}}</span>
              -
              <span>{{showTime(row.TimeBucketEnd)}}</span>
            </template>
          </el-table-column>
        </el-table>
      </div>
  </div>
</template>
<script>

export default {
  data() {
    return {
      api: require("@/api/attendance/teachersetting").default,
      data: {
        AttendanceTaskId: 0,
        Type: null,
      },
      range: null,
      failData: [
        // { TimeBucketStart: "2022-04-05 12:32:45", TimeBucketEnd: "2022-04-05 13:32:45", EventName: "事件名称1" }
      ],
      loading: false,
      isMB: this.$store.state.isMB,
    };
  },
  beforeMount() {
    
  },
  methods: {
    comfirn() {
      if(this.data.Type===null) {
        this.$message.error("请选择修正操作");
        return;
      } else if(this.data.Type==1 && this.range==null) {
        this.$message.error("请选择考勤时段");
        return;
      }
      this.failData = [];
      this.loading = true;
      var params = {
        AttendanceTaskId: this.$route.query.AttendanceTaskId, //替换Id
        Type: this.data.Type,
        TimeBucketStart: "",
        TimeBucketEnd: ""
      };
      if(this.data.Type==1) {
        params.TimeBucketStart = this.range[0];
        params.TimeBucketEnd = this.range[1];
      }
      this.api.changeTime(params).then(res => {
        this.loading = false;
        if(res.Code==0) {
          this.$message.success("修改成功");
        } else {
          if(res.Code==1&&res.Data) {
            this.$message.error("存在时段冲突的事件");
            this.failData = res.Data;
          } else {
            this.$message.error(res.Msg);
          }
        }
      })
    },
    showTime(v) {
      var arr = v.split(" ");
      var arr2 = arr[1].split(":");
      return arr2[0] + " : " + arr2[1];
    }
  }
};
</script>
<style lang="scss" scoped>
.event_box {
  margin: auto;
  width: 90vw;
  border: 1px solid #999;
  border-radius: 3px;
  font-size: 14px;
  .title {
    font-size: 14px;
    border-bottom: 1px solid #999;
    padding: 5px 0 5px 5px;
  }
  .event_item {
    padding: 20px 10px;
    .label {
      width: 22%;
      display: inline-block;
    }
    .content {
      width: 78%;
      display: inline-block;
    }
  }
  .event_footer {
    border-top: 1px solid #999;
    padding: 10px 15px;
  }
  .t_title {
    color: #f11;
    margin-bottom: 6px;
    display: block;
    font-size: 14px;
  }
}
</style>